
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireceb8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireceb8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $edjoj = parcelRequire("edjoj");
var $4790066c823bbd49$exports = {};
$4790066c823bbd49$exports = JSON.parse("{\"FTP_PATH\":\"/gwjp/\",\"PLATFORM\":\"qjp\",\"LANGUAGE\":\"ja-JP\",\"EFE_ACTIVITY_HOST\":\"https://efe-activity-jp.aseugame.com/\",\"PF_HOST\":\"https://pf.efunjp.com/\",\"PF_WEB_HOST\":\"https://m.aseugame.com/\",\"IMG_HOST\":\"https://imgi.efunjp.com/\",\"LOGIN_HOST\":\"https://loginjp.aseugame.com/\",\"GAME_HOST\":\"https://gamejp.aseugame.com/\",\"LOGIN_WEB_PATH\":\"https://m.aseugame.com/enter/login?from=\",\"CDN_HOST\":\"https://resjp-download.vsplay.com/res_jp\",\"PLATFORM_GAME_CODE\":\"efunqjpplatform\",\"GAME_GPID\":1,\"GAME_DEPT\":48,\"PLATFORM_TYPE\":\"\",\"CODE_VERSION\":\"1.0\",\"gameCode\":\"jpjsjs\",\"activityCode\":\"jpjsjsPre\"}");


const $ecac38a8395632cd$var$createStoreConfig = (selector, action, parentDom = 'body')=>({
        selector: selector,
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: action,
        label: action,
        parentDom: parentDom,
        once: true,
        storageKey: `click_pre_btn`,
        isPopup: false
    });
const $ecac38a8395632cd$export$86442f699be99a8d = [
    $ecac38a8395632cd$var$createStoreConfig('.kv-store .btn-ios', "\u9996\u9875\u8DF3\u8F6CApp Store", '.section-kv'),
    $ecac38a8395632cd$var$createStoreConfig('.kv-store .btn-gp', "\u9996\u9875\u8DF3\u8F6CGoogle Play", '.section-kv'),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="reward"] .btn-ios', "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CApp Store"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="reward"] .btn-gp', "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CGoogle Play"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="world"] .btn-ios', "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CApp Store"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="world"] .btn-gp', "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CGoogle Play"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="role"] .btn-ios', "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CApp Store"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="role"] .btn-gp', "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CGoogle Play"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="feature"] .btn-ios', "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CApp Store"),
    $ecac38a8395632cd$var$createStoreConfig('.floatbar[data-track-section="feature"] .btn-gp', "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CGoogle Play"),
    // createStoreConfig(
    //     '.reservation-popup.popup-from-mandatory .popup-btn-reservation[data-store-type="ios"]',
    //     '開屏彈窗跳轉App Store'
    // ),
    // createStoreConfig(
    //     '.reservation-popup.popup-from-mandatory .popup-btn-reservation[data-store-type="gp"]',
    //     '開屏彈窗跳轉Google Play'
    // ),
    $ecac38a8395632cd$var$createStoreConfig('.reservation-popup.popup-from-twenty-seconds .popup-btn-reservation[data-store-type="ios"]', "\u958B\u5C4F\u5F48\u7A97\u8DF3\u8F49App Store\uFF08\u505C\u755920s\uFF09"),
    $ecac38a8395632cd$var$createStoreConfig('.reservation-popup.popup-from-twenty-seconds .popup-btn-reservation[data-store-type="gp"]', "\u958B\u5C4F\u5F48\u7A97\u8DF3\u8F49Google Play\uFF08\u505C\u755920s\uFF09"),
    $ecac38a8395632cd$var$createStoreConfig('.reservation-popup.popup-from-scroll .popup-btn-reservation[data-store-type="ios"]', "\u958B\u5C4F\u5F48\u7A97\u8DF3\u8F49App Store\uFF08\u89D2\u8272\u9801\u5F48\u51FA\uFF09"),
    $ecac38a8395632cd$var$createStoreConfig('.reservation-popup.popup-from-scroll .popup-btn-reservation[data-store-type="gp"]', "\u958B\u5C4F\u5F48\u7A97\u8DF3\u8F49Google Play\uFF08\u89D2\u8272\u9801\u5F48\u51FA\uFF09")
];
const $ecac38a8395632cd$export$6765b5a94465d2ef = [
    ...$ecac38a8395632cd$export$86442f699be99a8d
];
const $ecac38a8395632cd$export$d08c3e2d57bcc098 = [
    ...$ecac38a8395632cd$export$86442f699be99a8d
];
const $ecac38a8395632cd$export$6c08efadf280ad2f = [];
const $ecac38a8395632cd$export$57db5728151e63c7 = [];


const $dde4db35e1150dc5$export$5a1b50986746c923 = '.popup-btn-reservation';
const $dde4db35e1150dc5$export$d7a271daff170df0 = [
    '.btn-gp',
    '.btn-and',
    '.btn-float.btn-gp',
    '.popup-btn-gp',
    `${$dde4db35e1150dc5$export$5a1b50986746c923}[data-store-type="gp"]`
].join(',');
const $dde4db35e1150dc5$export$8f4920b5ce0c57f6 = [
    '.btn-ios',
    '.btn-float.btn-ios',
    '.popup-btn-ios',
    `${$dde4db35e1150dc5$export$5a1b50986746c923}[data-store-type="ios"]`
].join(',');
const $dde4db35e1150dc5$export$939cf5b3080286bf = '.reservation-popup';
const $dde4db35e1150dc5$export$f4b5552990f5eb26 = '.store-confirm-popup';
const $dde4db35e1150dc5$export$2c51dddb1de22c5b = '.store-countdown-popup';
const $dde4db35e1150dc5$export$7678f182b4f0488a = '.countdown-timer';
const $dde4db35e1150dc5$export$36a37ca1a88d728a = '.section-role';
const $dde4db35e1150dc5$export$ba36743765e1264a = $dde4db35e1150dc5$export$2c51dddb1de22c5b;
const $dde4db35e1150dc5$export$a031478a8a29febd = `${$dde4db35e1150dc5$export$2c51dddb1de22c5b} .popup-btn-store`;
const $dde4db35e1150dc5$export$2cebba4a2e83e853 = `${$dde4db35e1150dc5$export$2c51dddb1de22c5b} .popup-btn-gp`;
const $dde4db35e1150dc5$export$a279c224b52c492 = `${$dde4db35e1150dc5$export$2c51dddb1de22c5b} .popup-btn-ios`;
const $dde4db35e1150dc5$export$d91119fa26993f11 = '';


const $c043dc842947a4bc$export$9666bbce1fb6a096 = {
    "ios": "https://apps.apple.com/jp/app/id6767176253",
    "gp": "https://play.google.com/store/apps/details?id=com.coc.jsjs",
    "fbClub": "https://www.facebook.com/groups/2343340346120341",
    "fbFans": "https://www.facebook.com/yulgangw.mover/",
    "twitter": "",
    "discord": ""
};
const $c043dc842947a4bc$export$aa92494dfa16499a = '';
const $c043dc842947a4bc$export$495b8a9a16d3b28e = {
    "Smart&&Click&&ios-tt": {
        "index": "5,7,8",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=c3fbd11e-1808-4050-8489-529eb5209fde"
    },
    "Smart&&Subscribe&&ios-pangle": {
        "index": "5,7,8",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=93073e7d-5fbc-4d11-b80d-0c27d9e8be98"
    },
    "Smart&&Click&&all-tt": {
        "index": "5,7,8",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=4d8df4c4-f6c9-4a13-83c6-3886a18374ed"
    },
    "dgv&&shorts": {
        "index": "5,6",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=4a178eef-c2e7-461d-8b21-592e820d8720"
    },
    "dg&&tanchuang": {
        "index": "5,6",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=4c2cd307-f699-4e1e-88f2-7021609f9267"
    },
    "dg": {
        "index": 5,
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=be24a2ca-a4ef-4b5c-b218-26b3b43dc202"
    },
    "dgv": {
        "index": 5,
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=c33f40bf-a517-4e38-bef1-fdfbe568105e"
    },
    "pmax": {
        "index": 5,
        "link": "https://apps.apple.com/jp/app/%E3%81%B7%E3%82%93%E3%81%B7%E3%82%93%E9%97%98%E7%A5%9E/id6767176253?ppid=5a43b830-c454-43cd-aab8-1c9793a67f37"
    },
    "fbresult&&SUBSCRIBE": {
        "index": "1,7",
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=95fd42e8-be35-4d26-b176-d6fabcc528ff"
    },
    "twitter": {
        "index": 1,
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=20310831-63f5-4c12-8918-31d080df9636"
    },
    "seedapp-zucks": {
        "index": 1,
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=5ed63615-72f4-443b-9f23-883fc2da5cdd"
    },
    "fukuro-zucks": {
        "index": 1,
        "link": "https://apps.apple.com/jp/app/\u3077\u3093\u3077\u3093\u95D8\u795E/id6767176253?ppid=304568a1-ab4a-43bd-a3c5-d88fc002040d"
    }
};
const $c043dc842947a4bc$export$523465427e649cc5 = {};
const $c043dc842947a4bc$export$fad8e825106d56c4 = {
    "Smart&&Click&&and-tt": {
        "index": "5,7,8",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=tt-smart-tiktok"
    },
    "Smart&&Subscribe&&and-pangle": {
        "index": "5,7,8",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=tt-smart-pangle"
    },
    "Smart&&Click&&all-tt": {
        "index": "5,7,8",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=tt-smart-all-tt"
    },
    "dgv&&shorts": {
        "index": "5,6",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=gg-dgv-shorts-click"
    },
    "dg&&tanchuang": {
        "index": "5,6",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=gg-dg-tanchuang"
    },
    "dg": {
        "index": 5,
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=gg-dg-click"
    },
    "dgv": {
        "index": 5,
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=gg-dgv-click"
    },
    "pmax": {
        "index": 5,
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=gg-pmax-click"
    },
    "fbresult&&SUBSCRIBE": {
        "index": "1,7",
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=fb-click"
    },
    "twitter": {
        "index": 1,
        "link": "https://play.google.com/store/apps/details?id=com.coc.jsjs&listing=twitter-click"
    }
};
const $c043dc842947a4bc$export$469595e4a4231f4f = {};



var $edjoj = parcelRequire("edjoj");

/** 排重标识 */ const $91e3366086257470$export$86880b4b2e1a2384 = {
    GTM_GP: 'track_gtm_all_shop_btn_gp',
    GTM_IOS: 'track_gtm_all_shop_btn_ios',
    GTM_SECOND_GP: 'track_gtm_second_shop_btn_gp',
    GTM_SECOND_IOS: 'track_gtm_second_shop_btn_ios',
    GTM_PRE: 'track_gtm_success_pop',
    FB_SHOP: 'track_fb_all_shop_btn',
    FB_PRE: 'track_fb_pre_success',
    TT_PRE: 'track_tt_pre_success',
    TT_SHOP: 'track_tt_all_shop_btn',
    TT_PANGLE: 'track_tt_pangle_btn',
    X_GP: 'track_x_all_shop_btn_gp',
    X_IOS: 'track_x_all_shop_btn_ios',
    ZAF_IOS: 'track_zaf_all_shop_btn_ios',
    SEEDAPP_IOS: 'track_seedapp_all_shop_btn_ios'
};


const $f87a224bf90dcb83$var$popupInstances = new Map();
const $f87a224bf90dcb83$var$popupOpenedSet = new Set();
const $f87a224bf90dcb83$var$popupCountdownTimers = new Map();
const $f87a224bf90dcb83$var$COUNTDOWN_TIMER_SELECTOR = '.countdown-timer';
const $f87a224bf90dcb83$var$COUNTDOWN_MILLISECONDS = 30000;
const $f87a224bf90dcb83$var$COUNTDOWN_INTERVAL = 10;
function $f87a224bf90dcb83$var$startPopupCountdown(selector) {
    const $timer = $(`${selector} ${$f87a224bf90dcb83$var$COUNTDOWN_TIMER_SELECTOR}`);
    if (!$timer.length) return;
    const previousTimer = $f87a224bf90dcb83$var$popupCountdownTimers.get(selector);
    if (previousTimer !== undefined) window.clearInterval(previousTimer);
    let remainingMilliseconds = $f87a224bf90dcb83$var$COUNTDOWN_MILLISECONDS;
    const render = ()=>{
        const minutes = Math.floor(remainingMilliseconds / 60000);
        const seconds = Math.floor(remainingMilliseconds % 60000 / 1000);
        const centiseconds = Math.floor(remainingMilliseconds % 1000 / 10);
        $timer.text([
            minutes,
            seconds,
            centiseconds
        ].map((value)=>String(value).padStart(2, '0')).join(':'));
    };
    render();
    const timer = window.setInterval(()=>{
        remainingMilliseconds = Math.max(remainingMilliseconds - $f87a224bf90dcb83$var$COUNTDOWN_INTERVAL, 0);
        render();
        if (remainingMilliseconds === 0) {
            window.clearInterval(timer);
            $f87a224bf90dcb83$var$popupCountdownTimers.delete(selector);
        }
    }, $f87a224bf90dcb83$var$COUNTDOWN_INTERVAL);
    $f87a224bf90dcb83$var$popupCountdownTimers.set(selector, timer);
}
function $f87a224bf90dcb83$export$c459441f6984099e() {
    const set = (selector, instance)=>{
        $f87a224bf90dcb83$var$popupOpenedSet.add(selector);
        $f87a224bf90dcb83$var$popupInstances.set(selector, instance);
    };
    const has = (selector)=>{
        return $f87a224bf90dcb83$var$popupInstances.has(selector);
    };
    const isOpened = (selector)=>{
        return !!$(selector).is(':visible');
    };
    const haveOpened = (selector)=>{
        return $f87a224bf90dcb83$var$popupOpenedSet.has(selector);
    };
    const openPopup = (selector, options)=>{
        closePopupAll();
        if (typeof $.fn.bPopup !== 'function') {
            $(selector).show();
            const instance = {
                close: ()=>$(selector).hide()
            };
            set(selector, instance);
            $f87a224bf90dcb83$var$startPopupCountdown(selector);
            return instance;
        }
        const instance = $(selector).bPopup(Object.assign({
            closeClass: 'b-close',
            modalClose: true,
            opacity: 0.82,
            positionStyle: 'fixed'
        }, options));
        set(selector, instance);
        $f87a224bf90dcb83$var$startPopupCountdown(selector);
        return instance;
    };
    const closePopup = (selector)=>{
        var _a;
        const instance = $f87a224bf90dcb83$var$popupInstances.get(selector);
        (_a = instance === null || instance === void 0 ? void 0 : instance.close) === null || _a === void 0 || _a.call(instance);
        $f87a224bf90dcb83$var$popupInstances.delete(selector);
    };
    const closePopupAll = ()=>{
        $f87a224bf90dcb83$var$popupInstances.forEach((instance)=>{
            var _a;
            try {
                (_a = instance === null || instance === void 0 ? void 0 : instance.close) === null || _a === void 0 || _a.call(instance);
            } catch (_b) {
            // 已关闭的弹窗再次调用 close 会报错。
            }
        });
        $f87a224bf90dcb83$var$popupInstances.clear();
        $('.popup-panel:visible').hide();
    };
    return {
        set: set,
        has: has,
        isOpened: isOpened,
        haveOpened: haveOpened,
        openPopup: openPopup,
        closePopup: closePopup,
        closePopupAll: closePopupAll
    };
}



var $edjoj = parcelRequire("edjoj");
var $159cc7e486f2a764$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $159cc7e486f2a764$export$260e882f431d977c() {
    let activityConfig = null;
    const getActivityConfig = ()=>$159cc7e486f2a764$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const { data: data } = yield (0, $edjoj.getActivityInfoByApi)('payType');
            try {
                data.activityMsgConfig.activityMsg.context = JSON.parse((_a = data.activityMsgConfig.activityMsg.context) !== null && _a !== void 0 ? _a : '{}');
                data.activityMsgConfig.activityMsg.payType = JSON.parse((_b = data.activityMsgConfig.activityMsg.payType) !== null && _b !== void 0 ? _b : '{}');
            } catch (_c) {
            //
            }
            activityConfig = data;
            return activityConfig !== null && activityConfig !== void 0 ? activityConfig : {};
        });
    return {
        getActivityConfig: getActivityConfig
    };
}



function $164e48e1c52b42e0$export$30a06c8d3562193f(object, keys) {
    const ownKeys = [
        ...Object.keys(object),
        ...Object.getOwnPropertySymbols(object)
    ];
    return ownKeys.reduce((result, key)=>{
        if (!keys.includes(key)) result[key] = object[key];
        return result;
    }, {});
}


var $7644592b74195952$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7644592b74195952$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { getActivityConfig: $7644592b74195952$var$getActivityConfig } = (0, $159cc7e486f2a764$export$260e882f431d977c)();
const { openPopup: $7644592b74195952$var$openPopup, closePopupAll: $7644592b74195952$var$closePopupAll } = (0, $f87a224bf90dcb83$export$c459441f6984099e)();
const $7644592b74195952$var$iosSecondSendTo = 'AW-18322019198/n0icCKzv4NAcEP6mz6BE';
const $7644592b74195952$var$gpSecondSendTo = 'AW-18322019198/my81CJ_94NAcEP6mz6BE';
let $7644592b74195952$var$_openIosPangle = false;
let $7644592b74195952$var$_openAndPangle = false;
function $7644592b74195952$var$gpStoreTrack(trackingGtm = true) {
    if (trackingGtm) (0, $edjoj.trackGTM)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_GP,
        data: {
            send_to: 'AW-18322019198/ISUSCMLdxdAcEP6mz6BE',
            value: 1.0,
            currency: 'USD'
        }
    });
    if (!(0, $edjoj.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).X_GP)) {
        twq === null || twq === void 0 || twq('event', 'tw-re0gk-re0jd', {
            conversion_id: null,
            email_address: null,
            phone_number: null
        });
        (0, $edjoj.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).X_GP, 1);
    }
}
function $7644592b74195952$var$iosStoreTrack(trackingGtm = true) {
    if (trackingGtm) (0, $edjoj.trackGTM)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_IOS,
        data: {
            send_to: 'AW-18322019198/K9gACLrE4NAcEP6mz6BE',
            value: 1.0,
            currency: 'USD'
        }
    });
    if (!(0, $edjoj.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).X_IOS)) {
        twq === null || twq === void 0 || twq('event', 'tw-re0gk-re0h7', {
            conversion_id: null,
            email_address: null,
            phone_number: null
        });
        (0, $edjoj.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).X_IOS, 1);
    }
    $7644592b74195952$var$zafIosStoreTrack();
    $7644592b74195952$var$seedappIosStoreTrack();
}
function $7644592b74195952$var$allStoreTrack(ttType = 'ClickButton') {
    (0, $edjoj.trackFB)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).FB_SHOP,
        event: 'Subscribe',
        data: {
            currency: 'USD',
            value: 0.0
        }
    });
    (0, $edjoj.trackTT)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).TT_SHOP,
        event: ttType
    });
}
function $7644592b74195952$var$zafIosStoreTrack() {
    if ((0, $edjoj.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).ZAF_IOS)) return;
    $('body').append(`<script> var cx_postback_option = "non_load" </script><script> var cx_params_7450 = { "oid": "\u{8A08}\u{6E2C}\u{7528}\u{6587}\u{5B57}\u{5217}", "ma_campaign_id": 7450 } </script><script src="https://s3.ap-northeast-1.amazonaws.com/x-storage.cir.io/weblink/multi_postback.js" id="cxPostback_7450"></script>`);
    (0, $edjoj.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).ZAF_IOS, '1');
}
function $7644592b74195952$var$seedappIosStoreTrack() {
    if ((0, $edjoj.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).SEEDAPP_IOS)) return;
    $('body').append(`
            <span id="a8sales"></span>
            <script src="//statics.a8.net/a8sales/a8sales.js"></script>
            <script>
            a8sales({
                pid: "s00000020278145",
                order_number: "1",
                currency: "JPY",
                items: [{
                    code: "1",
                    price: 1,
                    quantity: 1
                }],
                total_price: 1
            });
            </script>
            `);
    (0, $edjoj.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).SEEDAPP_IOS, '1');
}
function $7644592b74195952$var$openPanglePopup() {
    $7644592b74195952$var$closePopupAll();
    $7644592b74195952$var$openPopup((0, $dde4db35e1150dc5$export$ba36743765e1264a));
}
function $7644592b74195952$export$3c6b9e396446483e() {
    var _a, _b, _c;
    return $7644592b74195952$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const activityConfig = yield $7644592b74195952$var$getActivityConfig();
            const { openIosPangle: openIosPangle = false, openAndPangle: openAndPangle = false } = (_c = (_b = (_a = activityConfig === null || activityConfig === void 0 ? void 0 : activityConfig.activityMsgConfig) === null || _a === void 0 ? void 0 : _a.activityMsg) === null || _b === void 0 ? void 0 : _b.context) !== null && _c !== void 0 ? _c : {};
            $7644592b74195952$var$_openIosPangle = openIosPangle;
            $7644592b74195952$var$_openAndPangle = openAndPangle;
        } finally{
            const isAndPangle = $7644592b74195952$var$_openAndPangle && $7644592b74195952$export$ac429f11ac014fb5();
            const isIosPangle = $7644592b74195952$var$_openIosPangle && $7644592b74195952$export$f1a0c7bc35d9df48();
            if (isAndPangle) $((0, $dde4db35e1150dc5$export$2cebba4a2e83e853)).on('click', ()=>{
                $7644592b74195952$var$closePopupAll();
            });
            if (isIosPangle) $((0, $dde4db35e1150dc5$export$a279c224b52c492)).on('click', ()=>{
                $7644592b74195952$var$closePopupAll();
            });
            $7644592b74195952$var$listenStoreTrack(isAndPangle, isIosPangle);
        }
    });
}
function $7644592b74195952$var$listenStoreTrack(isAndPangle, isIosPangle) {
    console.log('isAndPangle', isAndPangle, 'isIosPangle', isIosPangle);
    const storeConfig = (0, $edjoj.isMb)() ? (0, $ecac38a8395632cd$export$6765b5a94465d2ef) : (0, $ecac38a8395632cd$export$d08c3e2d57bcc098);
    if (!isAndPangle && !isIosPangle) storeConfig.forEach((_a)=>{
        var { selector: selector, parentDom: parentDom } = _a, options = $7644592b74195952$var$__rest(_a, [
            "selector",
            "parentDom"
        ]);
        if (parentDom) $(parentDom).on('click', selector, ()=>(0, $edjoj.trackGA)(options));
        else $(selector).on('click', ()=>(0, $edjoj.trackGA)(options));
    });
    $(document).on('click', (0, $dde4db35e1150dc5$export$d7a271daff170df0), (e)=>{
        var _a;
        if ($(e.currentTarget).closest((0, $dde4db35e1150dc5$export$a031478a8a29febd)).length > 0) return;
        const $target = $(e.target);
        const ignored = $target.closest((0, $dde4db35e1150dc5$export$d91119fa26993f11)).length > 0;
        const triggedGaConfig = (_a = storeConfig.find(({ selector: selector })=>$target.closest(selector).length > 0)) !== null && _a !== void 0 ? _a : null;
        if (ignored && triggedGaConfig) (0, $edjoj.trackGA)((0, $164e48e1c52b42e0$export$30a06c8d3562193f)(triggedGaConfig, [
            'parentDom',
            'selector'
        ]));
        if (!ignored && isAndPangle) {
            $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).data('gaConfig', triggedGaConfig);
            e.preventDefault();
            $7644592b74195952$var$openPanglePopup();
        } else {
            $7644592b74195952$var$gpStoreTrack();
            $7644592b74195952$var$allStoreTrack();
        }
    });
    $(document).on('click', (0, $dde4db35e1150dc5$export$8f4920b5ce0c57f6), (e)=>{
        var _a;
        if ($(e.currentTarget).closest((0, $dde4db35e1150dc5$export$a031478a8a29febd)).length > 0) return;
        const $target = $(e.target);
        const ignored = $target.closest((0, $dde4db35e1150dc5$export$d91119fa26993f11)).length > 0;
        const triggedGaConfig = (_a = storeConfig.find(({ selector: selector })=>$target.closest(selector).length > 0)) !== null && _a !== void 0 ? _a : null;
        $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).data('gaConfig', triggedGaConfig);
        if (ignored && triggedGaConfig) (0, $edjoj.trackGA)((0, $164e48e1c52b42e0$export$30a06c8d3562193f)(triggedGaConfig, [
            'parentDom',
            'selector'
        ]));
        if (!ignored && isIosPangle) {
            e.preventDefault();
            $7644592b74195952$var$openPanglePopup();
        } else {
            $7644592b74195952$var$iosStoreTrack();
            $7644592b74195952$var$allStoreTrack();
        }
    });
    $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).on('click', (e)=>{
        console.log('PANGLE_BUTTONS clicked');
        const { type: type = 'gp', gaConfig: gaConfig = null } = $(e.currentTarget).data();
        const storeTrackGTM = type === 'gp' ? $7644592b74195952$var$gpStoreTrack : $7644592b74195952$var$iosStoreTrack;
        const storeTrackGTMEvent = !(type === 'gp' ? $7644592b74195952$var$gpSecondSendTo : $7644592b74195952$var$iosSecondSendTo);
        storeTrackGTM(storeTrackGTMEvent);
        $7644592b74195952$var$allStoreTrack('Subscribe');
        if (type === 'ios' && $7644592b74195952$var$iosSecondSendTo) (0, $edjoj.trackGTM)({
            once: true,
            storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_SECOND_IOS,
            data: {
                send_to: $7644592b74195952$var$iosSecondSendTo,
                value: 1.0,
                currency: 'USD'
            }
        });
        if (type === 'gp' && $7644592b74195952$var$gpSecondSendTo) (0, $edjoj.trackGTM)({
            once: true,
            storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_SECOND_GP,
            data: {
                send_to: $7644592b74195952$var$gpSecondSendTo,
                value: 1.0,
                currency: 'USD'
            }
        });
        if (gaConfig) (0, $edjoj.trackGA)((0, $164e48e1c52b42e0$export$30a06c8d3562193f)(gaConfig, [
            'parentDom',
            'selector'
        ]));
    });
}
function $7644592b74195952$export$eb384ffe03b07dcd() {
    return $7644592b74195952$var$_openIosPangle && $7644592b74195952$export$f1a0c7bc35d9df48();
}
function $7644592b74195952$export$b26f9241999587ca() {
    return $7644592b74195952$var$_openAndPangle && $7644592b74195952$export$ac429f11ac014fb5();
}
function $7644592b74195952$var$getCurrentDevicePangleRules(rules) {
    var _a;
    return (_a = (0, $edjoj.isMb)() ? rules.mb : rules.pc) !== null && _a !== void 0 ? _a : [];
}
function $7644592b74195952$export$f1a0c7bc35d9df48() {
    const params = (0, $edjoj.getCampaignName)();
    const rules = $7644592b74195952$var$getCurrentDevicePangleRules({
        "pc": [],
        "mb": [
            "^(?:[^_]*_){4}Smart_[^_]*_Subscribe_ios-pangle(?:_|$).*",
            "^(?:[^_]*_){4}dg_tanchuang(?:_|$).*"
        ]
    });
    return rules.some((r)=>new RegExp(r).test(params));
}
function $7644592b74195952$export$ac429f11ac014fb5() {
    const params = (0, $edjoj.getCampaignName)();
    const rules = $7644592b74195952$var$getCurrentDevicePangleRules({
        "pc": [],
        "mb": [
            "^(?:[^_]*_){4}Smart_[^_]*_Subscribe_and-pangle(?:_|$).*",
            "^(?:[^_]*_){4}dg_tanchuang(?:_|$).*"
        ]
    });
    return rules.some((r)=>new RegExp(r).test(params));
}


var $4e0ab7089fc43413$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $4e0ab7089fc43413$export$cbd0a4babc275a37() {
    // 初始化 ABT 视频
    $4e0ab7089fc43413$var$initVideo();
    $4e0ab7089fc43413$var$initUtilConfig();
    $4e0ab7089fc43413$var$initStoreBtnLink();
    $4e0ab7089fc43413$var$initStoreTrack();
    $4e0ab7089fc43413$var$initRewardStatus();
}
function $4e0ab7089fc43413$var$initVideo() {
    if (typeof window.lozad !== 'function' || !window.kvUrl) return;
    $('.kv-video').show().addClass('loaded').append(// @ts-ignore
    `<video class="kv-video-box lozad" autoplay muted loop playsinline><source src="${window.kvUrl}"></source></video>`);
    if ((0, $edjoj.isPc)()) $(window).on('hashchange', ()=>{
        var _a, _b;
        const { hash: hash } = window.location;
        if (hash === '#section-01') (_b = (_a = $(`.kv-video-box`)[0]) === null || _a === void 0 ? void 0 : _a.play) === null || _b === void 0 || _b.call(_a);
    });
}
function $4e0ab7089fc43413$var$initUtilConfig() {
    new (0, $edjoj.EFE_ACTIVITY_FE_UTIL)((0, (/*@__PURE__*/$parcel$interopDefault($4790066c823bbd49$exports))), $4e0ab7089fc43413$var$isPcLike() ? (0, $ecac38a8395632cd$export$57db5728151e63c7) : (0, $ecac38a8395632cd$export$6c08efadf280ad2f));
    $.extend($.fn.bPopup.defaults, {
        appendTo: '#app'
    });
}
function $4e0ab7089fc43413$var$initStoreBtnLink() {
    const { ios: ios, gp: gp } = (0, $c043dc842947a4bc$export$9666bbce1fb6a096);
    const iosLink = $4e0ab7089fc43413$var$normalizeLink((0, $c043dc842947a4bc$export$aa92494dfa16499a) || (0, $edjoj.toggleCppIOSLink)((0, $c043dc842947a4bc$export$495b8a9a16d3b28e), ios));
    const gpLink = $4e0ab7089fc43413$var$normalizeLink((0, $edjoj.toggleCppIOSLink)((0, $c043dc842947a4bc$export$fad8e825106d56c4), gp));
    const popupStoreType = (0, $edjoj.isIOS)() ? 'ios' : 'gp';
    $((0, $dde4db35e1150dc5$export$5a1b50986746c923)).attr('data-store-type', popupStoreType);
    $((0, $dde4db35e1150dc5$export$8f4920b5ce0c57f6)).attr({
        href: iosLink,
        target: !(0, $edjoj.isPc)() && (0, $edjoj.isIOS)() ? '' : '_blank'
    });
    $((0, $dde4db35e1150dc5$export$d7a271daff170df0)).attr({
        href: gpLink,
        target: '_blank'
    });
}
function $4e0ab7089fc43413$var$initStoreTrack() {
    (0, $7644592b74195952$export$3c6b9e396446483e)();
}
function $4e0ab7089fc43413$var$initRewardStatus() {
    return $4e0ab7089fc43413$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const { data: data } = yield (0, $edjoj.getPreNumInfoByApi)();
            $4e0ab7089fc43413$var$renderRewardStatus(Number(data === null || data === void 0 ? void 0 : data.totalPreNum) || 0);
        } catch (_a) {
            $4e0ab7089fc43413$var$renderRewardStatus(0);
        }
    });
}
function $4e0ab7089fc43413$var$renderRewardStatus(total) {
    $('.reward-card[data-reward-threshold]').each((_, element)=>{
        const $card = $(element);
        const threshold = Number($card.attr('data-reward-threshold'));
        const isAchieved = Number.isFinite(threshold) && total >= threshold;
        const $achieved = $card.find('.reward-achieved');
        $card.toggleClass('is-achieved', isAchieved);
        // $achieved.toggle(isAchieved).toggleClass('loaded', isAchieved)
        $achieved.attr('aria-hidden', String(!isAchieved));
    });
}
function $4e0ab7089fc43413$var$normalizeLink(link) {
    return link || 'javascript:void(0)';
}
function $4e0ab7089fc43413$var$isPcLike() {
    return document.documentElement.clientWidth > 750;
}



var $edjoj = parcelRequire("edjoj");

/**
 * @description 常规弹窗，预约成功弹窗、重复预约弹窗默认值
 */ const $cab16dc1899a1bac$export$3d39044d09a4e158 = 'popup-from-normal';
const $cab16dc1899a1bac$export$a18c942169fade7a = 'popup-from-scroll';
const $cab16dc1899a1bac$export$82dc3216555ec61b = 'popup-from-phone-error';
const $cab16dc1899a1bac$export$69a5c4db11feebd9 = 'popup-from-twenty-seconds';
const $cab16dc1899a1bac$export$f99d2a75e41721f0 = 'popup-from-mandatory';
const $cab16dc1899a1bac$export$a4165569915db275 = 'popup-from-bottom';
const $cab16dc1899a1bac$export$3d4b36e701fe7e83 = [
    $cab16dc1899a1bac$export$3d39044d09a4e158,
    $cab16dc1899a1bac$export$a18c942169fade7a,
    $cab16dc1899a1bac$export$69a5c4db11feebd9,
    $cab16dc1899a1bac$export$f99d2a75e41721f0,
    $cab16dc1899a1bac$export$82dc3216555ec61b,
    $cab16dc1899a1bac$export$a4165569915db275
];




var $f49e4188f78569fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const { gameCode: $f49e4188f78569fd$var$gameCode, activityCode: $f49e4188f78569fd$var$activityCode } = (0, (/*@__PURE__*/$parcel$interopDefault($4790066c823bbd49$exports)));
const $f49e4188f78569fd$var$preStatusKey = `${$f49e4188f78569fd$var$gameCode}_${$f49e4188f78569fd$var$activityCode}_pre_status`;
const $f49e4188f78569fd$var$FORCE_OPEN_PRE_POPUP_DELAY = 20000;
const { openPopup: $f49e4188f78569fd$var$openPopup, closePopupAll: $f49e4188f78569fd$var$closePopupAll } = (0, $f87a224bf90dcb83$export$c459441f6984099e)();
function $f49e4188f78569fd$export$36aff1fbb4f5dfc6() {
    return $f49e4188f78569fd$var$__awaiter(this, void 0, void 0, function*() {
        $f49e4188f78569fd$var$bindEvent();
    });
}
function $f49e4188f78569fd$export$89737c494f8cc4e9() {
    return !!(0, $edjoj.getLocalStorage)($f49e4188f78569fd$var$preStatusKey);
}
function $f49e4188f78569fd$export$e79e32a7737255d5() {
    (0, $edjoj.setLocalStorage)($f49e4188f78569fd$var$preStatusKey, 1);
}
function $f49e4188f78569fd$var$bindEvent() {
    // forceOpenPrePopup(0, POPUP_FROM_MANDATORY)
    $f49e4188f78569fd$var$forceOpenPrePopup($f49e4188f78569fd$var$FORCE_OPEN_PRE_POPUP_DELAY, (0, $cab16dc1899a1bac$export$69a5c4db11feebd9));
    $f49e4188f78569fd$var$scrollOpenPopup((0, $dde4db35e1150dc5$export$36a37ca1a88d728a));
    $(`${(0, $dde4db35e1150dc5$export$d7a271daff170df0)}, ${(0, $dde4db35e1150dc5$export$8f4920b5ce0c57f6)}`).on('click', ()=>{
        $f49e4188f78569fd$var$closePopupAll();
        $f49e4188f78569fd$export$e79e32a7737255d5();
    });
}
function $f49e4188f78569fd$var$forceOpenPrePopup(time = $f49e4188f78569fd$var$FORCE_OPEN_PRE_POPUP_DELAY, trackClass) {
    window.setTimeout(()=>{
        if ($f49e4188f78569fd$export$89737c494f8cc4e9() || $f49e4188f78569fd$var$hasOpenedPopup()) return;
        $f49e4188f78569fd$var$openPrePopup(trackClass);
    }, time);
}
function $f49e4188f78569fd$var$openPrePopup(sourceClass) {
    if (!$((0, $dde4db35e1150dc5$export$939cf5b3080286bf)).length) return;
    $f49e4188f78569fd$var$closePopupAll();
    $f49e4188f78569fd$var$setPrePopupSource(sourceClass);
    $f49e4188f78569fd$var$openPopup((0, $dde4db35e1150dc5$export$939cf5b3080286bf));
}
function $f49e4188f78569fd$var$setPrePopupSource(sourceClass) {
    $((0, $dde4db35e1150dc5$export$939cf5b3080286bf)).removeClass((0, $cab16dc1899a1bac$export$3d4b36e701fe7e83).join(' ')).addClass(sourceClass);
}
function $f49e4188f78569fd$var$hasOpenedPopup() {
    return $('.popup-panel:visible').length > 0;
}
function $f49e4188f78569fd$var$scrollOpenPopup(selector) {
    if ($f49e4188f78569fd$export$89737c494f8cc4e9()) return;
    const el = document.querySelector(selector);
    if (!el) return;
    let last = 0;
    const observer = new IntersectionObserver(([entry])=>{
        if ($f49e4188f78569fd$export$89737c494f8cc4e9() || last > 0) {
            observer.disconnect();
            return;
        }
        const now = Date.now();
        if (!entry.isIntersecting || now - last < 0 || $f49e4188f78569fd$var$hasOpenedPopup()) return;
        $f49e4188f78569fd$var$openPrePopup((0, $cab16dc1899a1bac$export$a18c942169fade7a));
        last = now;
    }, {
        threshold: 0.5
    });
    observer.observe(el);
}




$(()=>{
    (0, $4e0ab7089fc43413$export$cbd0a4babc275a37)();
    (0, $f49e4188f78569fd$export$36aff1fbb4f5dfc6)();
});


//# sourceMappingURL=jpjsjsPre.22cef646.js.map
